// NATIVE

// INSTALLED

// CUSTOM
import { logout, login } from './';
import { types } from '../../commons/types/types';
import { loginWithEmailPassword, recoverPassword, resetPassword } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { ILoginWithEmailPassword } from '../../commons/interfaces';
import { setPermissions, setUserPermissions } from '../permissions';
import { setNotificationsList } from '../notifications';
import {
  setEmployeesCumpleanosRedux,
  setEmployeesTareasPendientesRedux,
  setEmployeLateResumenRedux,
  setEmployePeriodoPruebaResumenRedux,
  setEmployeResumenRedux,
} from '../employee';

export const startLoginWithEmailPassword = ({
  email,
  password,
  app,
  recaptchaToken,
}: ILoginWithEmailPassword): any => {
  try {
    return async (dispatch: any) => {
      dispatch(checkingPreload());

      const result = await loginWithEmailPassword({ email, password, app, recaptchaToken });

      dispatch(unCheckingPreload());

      if (!result.ok) return result;

      const {
        user,
        token,
        permissions,
        user_permissions,
        companyName,
        notifications,
        resumenEmployees,
        resumenEmployeesLate,
        resumenEmployeesPeriodoPrueba,
        resumenEmployeesTareasPendientes,
        resumenEmpleadosCumpleanos,
        appsCompany,
        subscription,
        hasUpdates,
        newsUpdated,
      } = result.data;

      const user_storage = {
        displayName: user.name,
        photoURL: user.avatar ?? '',
        email: user.email,
        token: token,
        errorMessage: null,
        cliente: companyName,
        cargo: user.cargo,
        subscription: subscription,
      };

      // PERMISOS
      await window.localStorage.setItem(
        types.storage.permissionsStorage,
        JSON.stringify(permissions)
      );
      await dispatch(setPermissions(permissions));

      // PERMISOS USUARIO
      await window.localStorage.setItem(
        types.storage.userPermissionsStorage,
        JSON.stringify(user_permissions)
      );
      await dispatch(setUserPermissions(user_permissions));

      // user
      await window.localStorage.setItem(types.storage.userStorage, JSON.stringify(user_storage));
      if (hasUpdates) {
        await window.localStorage.setItem(types.storage.hasUpdatesStorage, 'true');
      } else {
        await window.localStorage.removeItem(types.storage.hasUpdatesStorage);
      }

      if (newsUpdated) {
        await window.localStorage.setItem(
          types.storage.newsUpdatedStorage,
          JSON.stringify(newsUpdated)
        );
      } else {
        await window.localStorage.removeItem(types.storage.newsUpdatedStorage);
      }
      await dispatch(login(user_storage));

      await dispatch(setUserPermissions(user_permissions));

      await dispatch(setNotificationsList(notifications));

      await dispatch(setEmployeResumenRedux(resumenEmployees));
      await dispatch(setEmployeLateResumenRedux(resumenEmployeesLate));
      await dispatch(setEmployePeriodoPruebaResumenRedux(resumenEmployeesPeriodoPrueba));
      await dispatch(setEmployeesTareasPendientesRedux(resumenEmployeesTareasPendientes));
      await dispatch(setEmployeesCumpleanosRedux(resumenEmpleadosCumpleanos));

      dispatch(unCheckingPreload());
    };
  } catch (error) {
    console.log('conooooooooooooooooooooooooooooooooooo ', error);
  }
};

export const startLogOut = (): any => {
  try {
    return async (dispatch: any) => {
      dispatch(checkingPreload());
      await window.localStorage.removeItem(types.storage.userStorage);
      await window.localStorage.removeItem(types.storage.permissionsStorage);
      await window.localStorage.removeItem(types.storage.userPermissionsStorage);
      await window.localStorage.removeItem(types.storage.hasUpdatesStorage);
      await window.localStorage.removeItem(types.storage.newsUpdatedStorage);
      await window.localStorage.removeItem('notificationsStorage');

      dispatch(logout());
      dispatch(unCheckingPreload());
    };
  } catch (error) {
    console.log('startLoginWithEmailPassword ', error);
  }
};

export const startRecoverPassword = (email: string, recaptchaToken?: string): any => {
  return async (dispatch: any) => {
    try {
      dispatch(checkingPreload());
      const result = await recoverPassword(email, recaptchaToken);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      dispatch(unCheckingPreload());
      console.log('startRecoverPassword ', error);
      return { ok: false, message: 'Error en la recuperación de contraseña' };
    }
  };
};

export const startResetPassword = (data: any): any => {
  return async (dispatch: any) => {
    try {
      dispatch(checkingPreload());
      const result = await resetPassword(data);
      dispatch(unCheckingPreload());
      return result;
    } catch (error) {
      dispatch(unCheckingPreload());
      console.log('startResetPassword ', error);
      return { ok: false, message: 'Error al restablecer la contraseña' };
    }
  };
};
